import { FC } from 'react';
import { AllieUserAssigned, UserAssignedType } from '../../../UserAssigned';
import { DataContentBaseProps } from './DataContent.types';

interface UseAssignedProps extends UserAssignedType {}

export const UserAssigned: FC<DataContentBaseProps<UseAssignedProps>> = ({
  data: { ...props },
}) => <AllieUserAssigned {...props} />;
